<template>
    
    <spinner v-if="!loaded" ></spinner>

    <div class="template analyze-page" v-else-if="loaded" > 
        

        <!--
        <div class="page-section col-12 mt-4 p-0 d-none" >
            <b-card no-body class="atlass-tabs" >
                <b-tabs card>
                    
                    <b-tab title="Engagement" @click="switchTab('engagement')" >
                            
                        <spinner v-if="!tabloaded" ></spinner>

                        <Engagement v-if="tabloaded && activeTab == 'engagement' " ></Engagement>
                            
                    </b-tab>
                    
                    <b-tab title="Attribution" @click="switchTab('analyze')" >
                        
                        <spinner v-if="!tabloaded" ></spinner>
                        
                        <AnalyzeV2 v-if="tabloaded && activeTab == 'analyze' " ></AnalyzeV2>
                        
                    </b-tab>
                    
                </b-tabs>
            </b-card>
        </div>
        -->    
    
        <div class="page-section col-12 p-0" >
            <ul class="horizontal-menu font-size-16 font-weight-bold overflow-auto" >

                <li class="d-none" >
                    <router-link :to="{name: 'Overview'}" > Overview </router-link>
                </li>

                <li>
                    <router-link :to="{name: 'Attribution'}" > Sales </router-link>
                </li>
                
                <li>
                    <router-link :to="{name: 'Engagement'}" > Engagement </router-link>
                </li>
                <li class="d-none" >
                    <router-link :to="{name: 'Acquisition'}" > Acquisition </router-link>
                </li>
                
                <li class="d-none" >
                    <router-link :to="{name: 'AnalyseFunnels'}" > Funnels </router-link>
                </li>
                
                <li class="d-none" >
                    <router-link :to="{name: 'FunnelAnalysis'}" > Funnel Analysis </router-link>
                </li>

            </ul>

            <div class="template-padding" > 
                <router-view></router-view>
            </div>
        </div>
        
    </div><!-- end content template-padding -->

</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
import moment from 'moment'
    
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
    
import analyzeToday from '@/components/analyzeToday.vue'    
import Attribution from '@/templates/analyze/Attribution'    
import Engagement from '@/templates/analyze/Engagement'    
    
import helper from '@/helpers/helpers.js';
    
export default{
    name: "organizations",
    components:{
        analyzeToday,
        Attribution,
        Engagement
    },
    data () {
        return {
            loaded : false,
            activeTab: 'engagement',
            tabloaded: false,
        }
    },
    beforeCreate: function (){
    
    },
    mounted: function(){
        
        this.loaded = true;
        setTimeout(function(){ this.tabloaded = true }.bind(this), 200 );

    },
    computed: {
    },
    methods: {
        switchTab( target = false ){
            
            this.tabloaded = false
            setTimeout(function(){ this.activeTab = target; this.tabloaded = true }.bind(this), 200 );
            
        }
        
    },
    computed:{
        isAdmin(){
            return this.$store.getters.isAdmin
        },
        userRole(){
            return this.$store.getters.getRole
        },
    },
}
</script>


<style lang="scss" >
    
    .tab-content{
        
    }
    
    .card-body{
        padding-left:0;
        padding-right:0;
    }

</style>


// WEBPACK FOOTER //
// src/templates/analyze/AnalyzePage.vue